<template>
    <SiteNavbar />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
    <SiteFooter />
</template>

<script setup>
import SiteNavbar from './components/commons/nav/SiteNavbar.vue';
import SiteFooter from "./components/commons/footer/SiteFooter.vue";
import { useCartStore } from "@/stores/cart.js";

useHead({
    title: 'Stationary',
    bodyAttrs: {
        class: ''
    },
    script: [ { innerHTML: '' } ]
})

const route = useRoute();
const cartStore = useCartStore();
onMounted(async () => {
    cartStore.initialize();
});
</script>


<style scoped>
.initial-popup {
    background-image: url('/images/initial-popup.jpg');
    width: auto;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
</style>